<template>
    <div :class="className">

        <slot name="prev" :value="inputValue"></slot>
        <vue-slider
            v-model="inputValueNumber"

            :marks="sliderMarks"
            :tooltip-formatter="sliderTooltipFormatter"

            :data="sliderData"
            :tooltip-placement="tooltipPlacement"
            tooltip="always"
        />
        <slot name="next" :value="inputValue"></slot>
        <div style="display: none;">
            <slot name="hidden" :value="inputValue"></slot>
        </div>

    </div>
</template>

<script>
    import VueSlider from 'vue-slider-component'

    import mixinInput from './mixinInput';

    export default {
        mixins: [ mixinInput ],
        components: {
            'vue-slider': VueSlider
        },
        props: {
            className: {
                type: String,
                default: ''
            },

            value: {
                type: [String, Number],
                default: '1'
            },

            maxValue: {
                type: [String, Number],
                default: null
            },
            minValue: {
                type: [String, Number],
                default: null
            },
            stepValue: {
                type: [String, Number],
                default: 1
            },
            defaultValuesList: {
                type: Object,
                default: null
            },
            defaultLabelList: {
                type: Object,
                default: null
            },
            marks:{
                type: Boolean,
                default: true,
            },
            tooltipPlacement:{
                type: String,
                default: 'top',
            }
        },
        data() {
            return {

            };
        },
        computed: {
            valuesList() {
                let valuesList = this.defaultValuesList;
                if( !valuesList ) {
                    valuesList = {};
                    for( let n = +this.minValue; n <= +this.maxValue; n++ ) {
                        valuesList[n+''] = n;
                    }
                }

                return valuesList;
            },
            sliderTooltipFormatter() {
                return ( value ) => {
                    return this.defaultLabelList[value+''];
                };
            },
            sliderMarks() {
                if(this.marks) {
                    return (value) => {
                        return {label: this.defaultValuesList[value + '']};
                    };
                }else{
                    return false;
                }
            },
            sliderData() {
                return Object.keys( this.valuesList ).map(value => !isNaN(+value) ? +value : value);
            }
        },
        watch: {
            defaultValue: {
                handler( defaultValue ) {
                    if( defaultValue !== this.value ) {
                        this.value = defaultValue;
                    }
                },
                deep: true
            }
        },
        mounted() {

        }
    }
</script>
